import FacebookRounded from "@mui/icons-material/FacebookRounded";
import Instagram from "@mui/icons-material/Instagram";
import OndemandVideoRoundedIcon from "@mui/icons-material/OndemandVideoRounded";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Link from "next/link";

export default function SocialLinks() {
  const socials = [
    {
      name: "Facebook",
      icon: <FacebookRounded />,
      link: "https://www.facebook.com/tibertutor",
    },
    {
      name: "Instagram",
      icon: <Instagram />,
      link: "https://www.instagram.com/tibertutor",
    },
    {
      name: "Youtube",
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/UC-oRhe5czsZM3JdTX_vm2Eg",
    },
    {
      name: "Vimeo",
      icon: <OndemandVideoRoundedIcon />,
      link: "https://vimeo.com/tibertutor",
    },
  ];
  return (
    <>
      {socials.map((social) => (
        <Link href={social.link} aria-label={social.name} key={social.name}>
          {social.icon}
        </Link>
      ))}
    </>
  );
}
